import type { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { IPublicDesktopV1FiltersGetMetaRequest } from 'shared/repositories/commercial-search-offers/desktop/v1/filters/get-meta';
import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = HttpBadStatusCodeError | UnknownError;

export type QueryKey = [
  EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetCount,
  IPublicDesktopV1FiltersGetMetaRequest,
];
export const getQueryKey = (parameters: QueryKey[1]): QueryKey => [
  EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetCount,
  parameters,
];
